/** This page is used for fast dev UI mockups
 * !Devs: Please clean up this component before git commit or cherry-pick and not include this in your commit
 * @returns
 */
const UISandbox = () => {
  return <></>;
};

export default UISandbox;
